import { MOVEFLEX_NUMBERS } from '../constants/moveflexnumbers.constants'
import { AxiosService } from './axios.service'
import { BlockchainService } from './blockchain.service'
import { SearchService } from './search.service'

/**
 * Defines the API methods for a admin
 */
export class AdminService extends SearchService {
	static baseURL = 'admin'

	/**
	 * Gets the list of roles of current user
	 * @return {Promise} sucesso e mensagens de erro
	 */
	static inactivateClient(clientId) {
		return AxiosService.post(`cliente/inativar`, { clientId })
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Gets a client by id
	 * @param {string} clientId The client's identifier
	 */
	static getClientById(clientId) {
		return AxiosService.get(`${AdminService.baseURL}/cliente/${clientId}`)
			.then(({ data }) => data.data)
			.catch(() => [])
	}

	/**
	 * Searches the users (only employees)
	 * @return {Promise<any[]>} List of employees
	 */
	static searchUsers(params) {
		return AxiosService.get(
			`${AdminService.baseURL}/consultar-funcionarios`,
			{
				params,
			}
		)
			.then(({ data }) => ({
				rows: data.data,
				totalRows: super.getTotalRows(data.data),
			}))
			.catch(() => ({ rows: [], totalRows: 0 }))
	}

	/**
	 * Updates client info
	 * @param {object} client The client's information
	 */
	static updateClient(client) {
		const requestData = {
			...client,
			active: !!active,
		}

		return AxiosService.post(
			`${AdminService.baseURL}/atualizar-cliente`,
			requestData
		)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Updates client benefit info
	 * @param {object} benefit The benefit data
	 */
	static updateClientBenefit(benefit) {
		return AxiosService.post(
			`${AdminService.baseURL}/atualizar-beneficio-cliente`,
			benefit
		)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Activates an user
	 * @param {object} params The userId to be activate
	 */
	static activateUser(params) {
		return AxiosService.post(`${AdminService.baseURL}/ativar`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Inactivates an user
	 * @param {object} params The userId to be inactivate
	 */
	static inactivateUser(params) {
		return AxiosService.post(`${AdminService.baseURL}/inativar`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Gets an user data
	 * @param {string} id The user's identifier
	 */
	static get(id) {
		return AxiosService.get(`${AdminService.baseURL}/${id}`).then(
			({ data }) => data
		)
	}

	/**
	 * Creates an user
	 * @param {object} params The user data
	 */
	static createUser(params) {
		return AxiosService.post(`${AdminService.baseURL}/criar`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Updates an user
	 * @param {object} params The user data
	 */
	static updateUser(params) {
		return AxiosService.post(
			`${AdminService.baseURL}/atualizar`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Get balance points for Moveflex user
	 */
	static getBalancePoints() {
		return BlockchainService.getPoints(MOVEFLEX_NUMBERS.MOVEFLEX).then(
			({ data }) => data
		)
	}

	/**
	 * Gets the points to expire into next thirth days of a Moveflex user
	 */
	static getPointsToExpireNextThirthDays(moveflexNumber) {
		return AxiosService.get(
			`${this.baseURL}/consultar-pontos-a-expirar/30?moveflexNumber=${moveflexNumber}`
		).then(({ data }) => data)
	}

	/**
	 * Gets balance points for Moveflex user
	 * @param {string} term The term to search
	 */
	static searchUsersToMovePoints(term) {
		return AxiosService.get(
			`${AdminService.baseURL}/consultar-usuarios-para-movimentar-pontos?term=${term}`
		).then(({ data }) => data)
	}

	/**
	 * Get users by name
	 * @param {string} name The name to search
	 */
	static searchUsersByName(name) {
		return AxiosService.get(
			`${AdminService.baseURL}/consultar-usuarios?term=${name}`
		).then(({ data }) => data)
	}

	/**
	 * Get balance points for Moveflex user
	 * @param {string} term The term to search
	 */
	static searchUsersToGetPointsExtract(term) {
		return AxiosService.get(
			`${AdminService.baseURL}/consultar-usuarios-para-obter-extrato?term=${term}`
		).then(({ data }) => data)
	}

	/**
	 * Get product options for the Select HTML element
	 */
	static getProductOptions() {
		return AxiosService.get(`vendas/produtos`).then(({ data }) => data)
	}
}
